export const formatName = (firstName: string, middleName: string, lastName: string): string => {
  if (!firstName && !lastName) return '';
  else if (middleName)
    return `${firstName[0].toUpperCase()}${firstName
      .substr(1)
      .toLowerCase()} ${middleName[0].toUpperCase()} ${lastName[0].toUpperCase()}${lastName.substr(1).toLowerCase()}`;
  else
    return `${firstName[0].toUpperCase()}${firstName.substr(1).toLowerCase()} ${lastName[0].toUpperCase()}${lastName
      .substr(1)
      .toLowerCase()}`;
};

export const formatId = (str: string): string => {
  if (str) {
    //removes speciall characters and spaces
    return str
      .replaceAll(/[^a-zA-Z ]/g, '')
      .replaceAll(/\s/g, '')
      .toLocaleLowerCase()
      .trim();
  } else return str;
};

export const formatPhone = (phoneNumber: string): string => {
  if (!phoneNumber) return '';
  const re = /^(1|)?(\d{3})(\d{3})(\d{4})$/;
  const tempPN = phoneNumber.trim().replace(/[^\w]/g, '');
  if (!re.test(tempPN)) return phoneNumber;
  return tempPN.replace(re, (match, g1, g2, g3, g4) => {
    return g1 ? `${g1} (${g2}) ${g3}-${g4}` : `(${g2}) ${g3}-${g4}`;
  });
};

export const unformatPhone = (phoneNumber: string): string => {
  try {
    if (phoneNumber) return phoneNumber.replace(/\D/g, '');
  } catch (err: any) {
    console.error(`Error in StringFormatter.unformatPhone(): ${err.message}`);
  }
  return '';
};

export const formatEmail = (str: string): string => {
  let email: string = str.trim().toUpperCase();
  email = `${email.split('.COM')[0]}.COM`; //strip out weird non-ascii chars trailing email
  return email;
};

export const toTitleCase = (str?: string): string | undefined =>
  str?.toLowerCase()?.replace(/(^\w{1})|(\s+\w{1})/g, (letter) => letter.toUpperCase());

export const removeTextFromStringCaseInsensitive = (stringToProcess: string | undefined, textToRemove: string): string => {
  if (!stringToProcess || stringToProcess.trim() === '') return '';
  if (!textToRemove || textToRemove.trim() === '') return stringToProcess;
  const regex = new RegExp(textToRemove, 'gi');
  return stringToProcess.replace(regex, '').replace(/\s{2,}/g, ' ').trim();
}

export function formatDateMonthDDYYYY(dateString: string): string {
  const date = new Date(dateString);
  if (date) {
    let month: string = date.toLocaleString('default', { month: 'long' });
    if (month == 'September') month = 'Sept.';
    else if (month.length >= 6) month = `${month.substring(0, 3)}.`;
    const year = date.getFullYear();
    const day = date.getDate();
    return `${month} ${day}, ${year}`;
  } else return '';
}
